<!--首页-->
<template>
  <div>
    <div class="box">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="activity-detail-top">
            <div class="top-info">
              <div class="info-top-box">
                <!--<img :src="row.pic_url" alt srcset />-->
                <div class="activity-detail-title">{{row.title}}</div>
                <div class="activity-detail-desc">{{row.desc}}</div>
              </div>
              <div class="info-main-box">
                <div class="activity-dynamic">
                  <span>动态</span>
                  <span>{{row.bbs_content_count}}</span> ·
                  <span>互动</span>
                  <span>{{row.bbs_activity_count}}</span>
                </div>
                <div class="info-dynamic-items">
                  <div class="dynamic-item" v-if="row.type_id>0" v-rblink="{name:'SaiFilesList',query:{saiqu:row.type_id}}">
                    <img src="../../../assets/images/activity/pic-shuo-1@2x.png" alt />
                    <div class="dynamic-item-title">通知文件</div>
                  </div>
                  <div class="dynamic-item" >
                    <img src="../../../assets/images/activity/pic-shuo-10@2x.png" alt />
                    <div class="dynamic-item-title">日程表</div>
                  </div>
                  <div class="dynamic-item" v-if="row.type_id>0" v-rblink="{name:'SaiStartList',query:{saiqu:row.type_id}}">
                    <img src="../../../assets/images/activity/pic-shuo-2@2x.png" alt />
                    <div class="dynamic-item-title">出场顺序</div>
                  </div>
                  <div class="dynamic-item"  v-if="row.type_id>0" v-rblink="{name:'SaiResult',query:{saiqu:row.type_id}}">
                    <img src="../../../assets/images/activity/pic-shuo-4@2x.png" alt />
                    <div class="dynamic-item-title">成绩查询</div>
                  </div>
                  <div class="dynamic-item"  @click="onShisu()" >
                    <img src="../../../assets/images/activity/pic-shuo-9@2x.png" alt />
                    <div class="dynamic-item-title">食宿安排</div>
                  </div>
                  <div class="dynamic-item"  @click="onResults()" >
                    <img src="../../../assets/images/activity/pic-shuo-5@2x.png" alt />
                    <div class="dynamic-item-title">成绩册下载</div>
                  </div>
                  <div class="dynamic-item" @click="onZhixuce()">
                    <img src="../../../assets/images/activity/pic-shuo-6@2x.png" alt />
                    <div class="dynamic-item-title">秩序册下载</div>
                  </div>
                  <div class="dynamic-item" @click="onWenjuan()" >
                    <img src="../../../assets/images/activity/pic-shuo-7@2x.png" alt />
                    <div class="dynamic-item-title">调查问卷</div>
                  </div>
                  <div class="dynamic-item"  v-if="row.type_id>0" v-rblink="{name:'ISaiApplyFormStep1',query:{saiqu_id:row.type_id}}">
                    <img src="../../../assets/images/activity/pic-shuo-8@2x.png" alt />
                    <div class="dynamic-item-title">立即报名</div>
                  </div>
                  <div class="dynamic-item" @click="onZhibo()">
                    <img src="../../../assets/images/activity/pic-shuo-3@2x.png" alt />
                    <div class="dynamic-item-title">直播</div>
                  </div>
                </div>
              </div>
              <div class="info-bottom-box" v-if="false">
                <img src="../../../assets/images/activity/icon-shuo-notice@2x.png" alt />
                <div style="width:1px;height:15px;background:rgba(0,0,0,1);opacity:0.16;"></div>
                <div class="start-immediately">赛事马上开始咯~</div>
              </div>
            </div>
          </div>

          <van-tabs v-model="active" class="active-tab" sticky @click="onClick">
            <van-tab v-for="(item,index) in activeTab" :key="index" :type="index">
              <template #title>
                <span class="active-tab-num" v-if="item.num>0">{{item.num}}</span>
                {{item.name}}
              </template>
              <div
                v-for="(item ,i) in row.list.list"
              >
                <!-- 小图 style==1 -->
                <Activity1 v-if="item.style=='1'" :content="item" :index="i"></Activity1>

                <!-- 视频 style==2 -->
                <Activity2 v-if="item.style=='2'" :content="item" :index="i"></Activity2>

                <!-- 视频带评论 style==3 -->
                <Activity3
                  v-if="item.style=='3'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event,item,i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event,item,i)"
                  @deleteComment="onDeleteComment($event,i)"
                ></Activity3>

                <!-- 多图带评论 style==4 -->
                <Activity4
                  v-if="item.style=='4'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event,item,i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event,item,i)"
                  @deleteComment="onDeleteComment($event,i)"
                ></Activity4>
                <Activity5
                  v-if="item.style=='5'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event,item,i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event,item,i)"
                  @deleteComment="onDeleteComment($event,i)"
                ></Activity5>
              </div>
            </van-tab>
          </van-tabs>
          <div class="comment-bottom" v-if="sendShow">
            <div class="send-comment">
              <van-field v-model="message" :placeholder="placeholder" show-word-limit />
              <div class="send-btn" @click="onCommentSend">发送</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    <div
      class="to-form-add"
      v-rblink="{name:'ActivityContentForm',query:{'activity_id':this.$route.query.id}}"
    >
      <img src="../../../assets/images/activity/bg-btn-post@2x.png" alt srcset />
    </div>
    <van-action-sheet
  v-model="sheetActiveShow"
  :actions="sheetActiveActions"
  cancel-text="取消"
  close-on-click-action
  @cancel="onSheetCancel"
  @select="onSelect"
/>
<van-action-sheet
  v-model="sheetCommentShow"
  :actions="sheetCommentActions"
  cancel-text="取消"
  close-on-click-action
  @cancel="onSheetCancel"
  @select="onSelect"
/>
  </div>
</template>
<style scoped>
/* @import '../../assets/style/index.css'; */
.to-form-add {
  width: 1.1rem;
  height: 1.1rem;
  position: fixed;
  right: 0.2rem;
  top: 9rem;
  z-index: 3;
}
.to-form-add img {
  width: 100%;
}
.send-btn {
  width: 1.3rem;
  height: 38px;
  background: linear-gradient(
    90deg,
    rgba(254, 200, 53, 1) 0%,
    rgba(255, 173, 25, 1) 100%
  );
  border-radius: 4px;
  margin-left: 12px;
  line-height: 38px;
  text-align: center;
  font-size: 16px;
  
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.send-comment {
  width: 7.1rem;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}
.comment-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.08rem;
  background: rgba(247, 247, 247, 1);
  border: 1px solid rgba(236, 236, 236, 1);
}
.release-time-right {
  display: flex;
}
.icon-zan-comment-box {
  width: 175px;
  height: 38.5px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
}
.activity-place {
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}
.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}
.user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-face img {
  height: 32px;
  width: 32px;
}
.user-info {
  margin-left: 5px;
  float: left;
}
.user-info view {
  height: 50px;
  line-height: 50px;
}
.user-names {
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.look-info {
  height: 17px;
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  line-height: 17px;
}
.video-bottom {
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 5px;
}
.video-box img {
  margin-top: 10px;
  width: 100%;
}
.active-items-title-read {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 58%;
}
.active-item-title {
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.active-item-pics {
  width: 40%;
}
.active-item-pics img {
  width: 100%;
  height: 1.4rem;
}
.acitve-item-title {
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.active-itme-read {
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.acitve-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
}
.video-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
}
.active-tab {
  margin-top: 0.6rem;
}
.active-tab-num {
  width: 0.34rem;
  height: 0.34rem;
  background: #f05656;
  text-align: center;
  line-height: 0.34rem;
  display: block;
  position: absolute;
  right: -10px;
  top: -10px;
  border-radius: 0.34rem;
  color: #fff;
}
.active-tab >>> .van-tab__text {
  position: relative;
}
.active-tab >>> .van-tabs__nav {
  background: #f8f8f8;
}
.active-tab >>> [class*="van-hairline"]::after {
  border-top: none;
}
.activity-detail-top {
  width: 100%;
  background-size: 100% 4.69rem;
  background: url("../../../assets/images/activity/pic-shuo-top-1@2x.png")
    no-repeat;
  background-size: 100%;
  position: relative;
  overflow: hidden;
}
.top-info {
  width: 6.9rem;
  /*height: 5.3rem;*/
  background: rgba(255, 255, 255, 1);
  border-radius: 7px;
  margin: 2.1rem auto;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
}
.info-top-box {
  /*height: 1.45rem;*/
  padding: 0.26rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
}
.info-top-box img {
  width: 1.08rem;
  height: 1.08rem;
  position: absolute;
  top: -0.36rem;
}
.activity-detail-title {
  font-size: 19px;
  font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin: 5px 0;
  /*text-indent: 1.34rem;*/
}
.activity-detail-desc {
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 18px;
}
.info-main-box {
  /* height: 2.4rem; */
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  padding: 0.2rem;
}
.activity-dynamic {
  height: 33px;
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 33px;
  text-indent: 0.28rem;
}
.info-dynamic-items {
  display: flex;
  justify-content: space-between;
  flex: 1;
  flex-wrap: nowrap;
  overflow-y: scroll;
}
.info-dynamic-items .dynamic-item {
  min-width: 25%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  /* margin-right: 0.5rem; */
}
.dynamic-item img {
  width: 0.6rem;
  height: 0.6rem;
  display: block;
  margin-bottom: 0.12rem;
}

.info-bottom-box {
  flex: 1;
  display: flex;
  align-items: center;
}
.info-bottom-box img {
  width: 24px;
  height: 24px;
  display: block;
  margin: 0 0.16rem 0 0.28rem;
}
.start-immediately {
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  margin-left: 0.14rem;
}
.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
</style>

<script>
import Vue from "vue";
import { Tab, Tabs, Toast, Field, List, PullRefresh,ActionSheet } from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(Toast)
  .use(Field)
  .use(PullRefresh)
  .use(List).use(ActionSheet);
import Activity1 from "@/components/activity/Activity1.vue";
import Activity2 from "@/components/activity/Activity2.vue";
import Activity3 from "@/components/activity/Activity3.vue";
import Activity4 from "@/components/activity/Activity4.vue";
import Activity5 from "@/components/activity/Activity5.vue";

import LoginDialog from "@/components/LoginDialog.vue";

import { getTimeFormat } from "../../../utils/date.js";

export default {
  name: "Activity",
  components: {
    Activity1,
    Activity2,
    Activity3,
    Activity4,
    Activity5,
    LoginDialog
  },
  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      loginShow: false,
      sheetActiveShow:false,
      sheetCommentShow:false,
      Loop: null,
      active: 0,
      activeTab: [
        { name: "动态", num: 0, type: 0 },
        { name: "图片", num: 0, type: 1 },
        { name: "视频", num: 0, type: 2 }
      ],
      sheetActiveActions: [{ name: '删除主题' }],
      sheetCommentActions: [{ name: '删除评论' }],
      row: {
        id: 0,
        pic: [],
        pics: [],
        list: []
      },
      params: {
        id: 0,
        type: 0, //0动态 1是图片  2是视频
        pageNo: 1
      },
      message: "",
      sendShow: false,
      item: {}, //当前评论的item
      list_index: 0, //当前评论的列表下标
      to_comment_id: 0, //点击评论回复其人的id
      placeholder: "说点什么...",
      touchstartId:0, //长按后的id
      touchstartIndex:0 ,//长按后的下标
      commentIndex:0,//长按后评论下标
    };
  },
  filters: {
    getTimeFormat: getTimeFormat
  },
  mounted() {
    document.title = "活动";
    this.row.id = this.$route.query.id;
    this.params.id = this.$route.query.id;

    this.params.pageNo = 1;
    this.loading = true;
    this.finished = false;
    this.fetch();
  },
  destroyed() {},
  methods: {
    onZhibo(){
      if(this.row.zhibo_url){
        rbLink({
          name:'H5',
          query:{
            url: this.row.zhibo_url
          }
        })
      }else{
        Toast('暂未开通!');
      }
    },
    onWenjuan(){
      Toast('暂未开通!');
    },
    onZhixuce(){
      Toast('暂未开通!');
    },
    onResults(){
      Toast('暂未开通!');
    },
    onShisu(){
      Toast('暂未开通!');
    },
    activeDetele(){
      //删除话题
      let that=this
      console.log('shanchu',this.touchstartId)
      that.$api.get(
        "/api/activity/topicDelete",
        {id:this.touchstartId},
        res => {
          this.row.list.list.splice(this.touchstartIndex,1) 
           Toast('删除成功!');
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    CommentDetele(){
      //删除评论
      let that=this
      let id=this.row.list.list[this.touchstartIndex].comment_list[this.commentIndex].id
      that.$api.get(
        "/api/activity/commentDelete",
        {id:id},
        res => {
          this.row.list.list[this.touchstartIndex].comment_list.splice(that.commentIndex,1)
           Toast('删除成功!');
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    
    onSelect(action,index){
      console.log(action,index)
      switch (action.name){
        case '删除主题':
          this.activeDetele()
        break;
        case '删除评论':
           this.CommentDetele()
        break;
      } 
    },
    onSheetCancel() {
      // Toast('取消');
    },
    onDeleteActive(event,item,i){
      //删除主题
      this.touchstartId=item.id
      this.touchstartIndex=i
      this.sheetActiveShow=true
    },
    onDeleteComment(event,i){
      // 删除评论
      console.log(event,i)
      this.touchstartIndex=i
      this.commentIndex=event
      this.sheetCommentShow=true
    },
    onClick(name, title) {
      console.log(name);
      this.params.type = this.activeTab[name].type;
      this.params.pageNo = 1;
      this.fetch();
    },
    toActivityDetail(item) {
      let that = this;
      that.$router.push({
        path: "/activity-activity-detail",
        query: {
          id: item.id
        }
      });
    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/activity/activity",
        that.params,
        res => {
          that.loading = false;

          if (res.data.list.currentpage == 1) {
            that.isLoading = false;
            that.row = res.data;
          } else {
            that.row.list.list = that.row.list.list.concat(res.data.list.list);
          }

          if (res.data.list.list.length == 0) {
            that.finished = true;
          }
          that.params.pageNo += 1;
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    onSendBox(event, item, i) {
      // console.log(event)
      this.sendShow = event.sendShow;
      this.to_comment_id = event.comment_.id;
      this.placeholder = event.comment_.user_name
        ? "@" + event.comment_.user_name
        : "说点什么...";
      (this.item = item), (this.list_index = i);
    },
    onLoginStatus(event) {
      this.loginShow = true;
    },
    onCommentSend() {
      let that = this;
      console.log("发送评论", this.item, this.message);
      that.$api.get(
        "/api/activity/commentAdd",
        {
          topic_id: this.item.id,
          content: this.message,
          to_comment_id: this.to_comment_id
        },
        res => {
          console.log(res);
          this.row.list.list[this.list_index].comment_list.push(res.data);
          this.message = "";
        },
        res => {

          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                      {
                        name: "login",
                        query: {}
                      },
                      "replace"
              );
              return false;
            }
            that.loginShow = true
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.fetch();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
       this.loginShow = false;
    },
    showDeleteButton(e) {
      clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
      this.Loop = setTimeout(
        function() {
          console.log(e)
          if(e.is_admin){
            this.activeListId=e.id
            this.sheetActiveShow=true
          }
        }.bind(this),
        800
      );
    },
    emptyTime() {
      clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
    }
  }
};
</script>



// WEBPACK FOOTER //
// Activity.vue?6258a0b4